// @ts-ignore
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const GemsApiCertificateFragmentDoc = gql`
    fragment gemsApiCertificate on GemsApi_Stone {
  certificates {
    gcal
    gia
    igi
  }
}
    `;